import React from 'react';
import CustomSelector from '@shared/components/CustomSelector';

const RANKING_MAX = 10;
const ASSIGNMENT_RANK_FIELD = 'assignmentRank';

const rankingNAOption = { value: '', title: 'N/A' };

const rankingOptions = [
  rankingNAOption,
  ...Array.from({ length: RANKING_MAX }, (_, i) => i + 1).map(value => ({
    value: value,
    title: value
  }))
];

/**
 * @typedef {object} EventAssignmentsTableRankColumnRowRecord
 * @property {number} externalUserId
 */

/**
 * @typedef {object} EventAssignmentsTableRankColumnProps
 * @property {number} [rankValue]
 * @property {(externalUserId: number, newValue: number | string | null, field: string) => void} [setATMValue]
 * @property {EventAssignmentsTableRankColumnRowRecord} rowRecord
 * @property {Array<number>} takenRankings
 * @property {boolean} [disabled]
 */

/**
 * @param {EventAssignmentsTableRankColumnProps} props
 */
const EventAssignmentsTableRankColumn = props => {
  const { rankValue, setATMValue, rowRecord, takenRankings, disabled } = props;

  return (
    <CustomSelector
      testId={`${rowRecord.externalUserId}-ranking`}
      value={rankValue ?? ''}
      setValue={newValue => {
        setATMValue(rowRecord.externalUserId, newValue || null, ASSIGNMENT_RANK_FIELD);
      }}
      disabled={disabled}
      options={buildSelectableRankingOptions(takenRankings, rankValue)}
    />
  );
};

const buildSelectableRankingOptions = (takenRankings, currentRank) =>
  rankingOptions.map(option => {
    if (option.value === rankingNAOption.value || option.value === currentRank) {
      return option;
    }

    return {
      ...option,
      disabled: takenRankings.includes(option.value)
    };
  });

export default EventAssignmentsTableRankColumn;
